export class FbConfig {
  static DEBUG = false;

  // debug
	static DEBUG_HTTP_PORT = "61196";
  static DEBUG_USD_HTTPS_PORT = "61197";
  static DEBUG_HTTPS_PORT = "10062";
	static DEBUG_IADS_HOSTNAME = "aster.ahsayhqt.local";
  static DEBUG_USD_IADS_HOSTNAME = "usds001.kintips.com";
	static DEBUG_IADS_BASE_URL = "http://" + FbConfig.DEBUG_IADS_HOSTNAME + ":" + FbConfig.DEBUG_HTTP_PORT + "/iads";
	static DEBUG_CHECK_VERSION_URL = "http://" + FbConfig.DEBUG_IADS_HOSTNAME + ":" + FbConfig.DEBUG_HTTP_PORT + "/m/version.json";
	//static DEBUG_FB_WEB_SOCKET_PATH = "ws://" + FbConfig.DEBUG_IADS_HOSTNAME + ":" + FbConfig.DEBUG_HTTP_PORT + "/ws/clientFb";
  static DEBUG_WEB_SOCKET_PATH = "ws://" + FbConfig.DEBUG_IADS_HOSTNAME + ":" + FbConfig.DEBUG_HTTP_PORT + "/ws/client";
  static DEBUG_KINTIPS_URL = "http://" + FbConfig.DEBUG_IADS_HOSTNAME + ":" + FbConfig.DEBUG_HTTP_PORT + "/m/index.html";
  static DEBUG_PRICE_LIST_URL = "http://" + FbConfig.DEBUG_IADS_HOSTNAME + ":" + FbConfig.DEBUG_HTTP_PORT + "/fbTipsPrice.jsp";
  static DEBUG_PROTOCOL = "http";

  // production
  static PRD_HTTP_PORT = "80";
  static PRD_HTTPS_PORT = "443";
  static PRD_USD_HTTPS_PORT = "61197";
	// static PRD_IADS_HOSTNAME = "iads001.kintips.com";
  static PRD_IADS_HOSTNAME = "nxt-iads001.kintips.com";
	static PRD_USD_IADS_HOSTNAME = "usds001.kintips.com";
	static PRD_IADS_BASE_URL = "https://" + FbConfig.PRD_IADS_HOSTNAME + ":" + FbConfig.PRD_HTTPS_PORT + "/iads";
	static PRD_CHECK_VERSION_URL = "https://" + FbConfig.PRD_IADS_HOSTNAME + ":" + FbConfig.PRD_HTTPS_PORT + "/m/version.json";
	//static PRD_FB_WEB_SOCKET_PATH = "wss://" + FbConfig.PRD_IADS_HOSTNAME + ":" + FbConfig.PRD_HTTPS_PORT + "/ws/clientFb";
  static PRD_WEB_SOCKET_PATH = "wss://" + FbConfig.PRD_IADS_HOSTNAME + ":" + FbConfig.PRD_HTTPS_PORT + "/ws/client";
  static PRD_KINTIPS_URL = "https://" + FbConfig.PRD_IADS_HOSTNAME + ":" + FbConfig.PRD_HTTPS_PORT + "/m/index.html";
  static PRD_PRICE_LIST_URL = "https://" + FbConfig.PRD_IADS_HOSTNAME + ":" + FbConfig.PRD_HTTPS_PORT + "/fbTipsPrice.jsp";
  static PRD_PROTOCOL = "https";


  static getIadsBaseUrl() {
    if (FbConfig.DEBUG) {
      return FbConfig.DEBUG_IADS_BASE_URL;
    } else {
      return FbConfig.PRD_IADS_BASE_URL;
    }
  }

  static getKintipsUrl() {
    if (FbConfig.DEBUG) {
      return FbConfig.DEBUG_KINTIPS_URL;
    } else {
      return FbConfig.PRD_KINTIPS_URL;
    }
  }

  static getPriceListUrl() {
    if (FbConfig.DEBUG) {
      return FbConfig.DEBUG_PRICE_LIST_URL;
    } else {
      return FbConfig.PRD_PRICE_LIST_URL;
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/FbConfig.ts